<div class="flex flex-col gap-xs">
  @if (toDecideCount()) {
    <h2 class="reset-h text-xl font-bold text-default">
      @if (toDecideCount() === 1) {
        {{ '1 field to decide' | translate }}
      } @else {
        {{ '[count] fields to decide' | translate: { count: toDecideCount() } }}
      }
    </h2>

    @if (matchedCount()) {
      <p class="reset-p text-base text-support">
        {{ '[count] more matched to fields you already have. Check those too.' | translate: { count: matchedCount() } }}
      </p>
    }
  } @else if (matchedCount()) {
    <h2 class="reset-h text-xl font-bold text-default">
      @if (matchedCount() === 1) {
        {{ '1 field matched' | translate }}
      } @else {
        {{ 'All [count] fields matched' | translate: { count: matchedCount() } }}
      }
    </h2>
    <p class="reset-p text-base text-support">
      {{ 'They all use fields you already have. Check they’re right before you continue.' | translate }}
    </p>
  } @else {
    <h2 class="reset-h text-xl font-bold text-default">{{ 'No fields found' | translate }}</h2>
    <p class="reset-p text-base text-support">
      {{ 'Nothing in this document looks like it changes from one contract to the next.' | translate }}
    </p>
  }
</div>

@if (blankCards().length) {
  <sb-notice variant="info">{{ 'These fields were found by AI. Please double check them.' | translate }}</sb-notice>
}

@if (rejectedFile()) {
  <sb-notice variant="danger">{{ 'Only .docx files are supported.' | translate }}</sb-notice>
}

@if (openCards().length) {
  <ul class="reset-ul flex flex-col gap-md" [attr.aria-label]="'Fields to decide' | translate">
    @for (card of openCards(); track card.key) {
      <li>
        <field-card [card]="card" [decisions]="decisions()" (decided)="decided.emit($event)" />
      </li>
    }
  </ul>
}

@if (answeredCards().length) {
  <sb-accordion>
    <sb-accordion-panel>
      <sb-accordion-header>
        <div class="flex items-center gap-md">
          <span
            class="flex size-xl shrink-0 items-center justify-center rounded-full bg-success-subtle text-success"
            aria-hidden="true"
          >
            <sb-icon name="check-regular" />
          </span>
          <div class="flex flex-col">
            <span class="text-base font-semibold text-default">
              @if (matchedCount() === 1) {
                {{ '1 matched field' | translate }}
              } @else {
                {{ '[count] matched fields' | translate: { count: matchedCount() } }}
              }
            </span>
            <span class="text-sm text-support">{{
              'Shiftbase can get these wrong too. Open to check them.' | translate
            }}</span>
          </div>
        </div>
      </sb-accordion-header>
      <ul class="reset-ul flex flex-col gap-md" [attr.aria-label]="'Matched fields' | translate">
        @for (card of answeredCards(); track card.key) {
          <li>
            <field-card [card]="card" [decisions]="decisions()" (decided)="decided.emit($event)" />
          </li>
        }
      </ul>
    </sb-accordion-panel>
  </sb-accordion>
}

<missing-field-panel (uploadAgain)="fixedFile.click()" />

<input
  #fixedFile
  class="hidden"
  type="file"
  tabindex="-1"
  accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  [attr.aria-label]="'Fixed document' | translate"
  (change)="chooseFile(fixedFile)"
/>
